/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { closelightbox } from "../../util/Functions";
import { Grid, Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Tabs, Tab } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import ReactJson from "react-json-view";
import XMLViewer from "react-xml-viewer";
import moment from "moment";
import "moment/locale/es";

const InfoLogTutuka = (props) => {
  const [content, setContent] = useState({});
  const [tabActive, setTabActive] = useState("JSON");
  const [reqJson, setReqJson] = useState({});
  const [resJson, setResJson] = useState({});
  const [reqXml, setReqXml] = useState('<?xml version="1.0"?>');
  const [resXml, setResXml] = useState('<?xml version="1.0"?>');
 
  useEffect(() => {
    console.log(props.contentModal);
    setContent(JSON.parse(JSON.stringify(props.contentModal)));
    init();
  }, []);

  const changeTab = (index) => {
    setTabActive(index);
  };

  const init = () => {
    const cont = props.contentModal;
    try {
      let a = JSON.parse(cont["content"]["response"]["json"]);
      setResJson(a);
    } catch (e) {
      setResJson({ error: cont["content"]["response"]["json"] });
    }

    try {
      let a = JSON.parse(cont["content"]["request"]["json"]);
      setReqJson(a);
    } catch (e) {
      setReqJson({ error: cont["content"]["request"]["json"] });
    }

    let xmlReq = '<?xml version="1.0"?>';
    let xmlRes = '<?xml version="1.0"?>';
    if (cont["content"]["response"]["xml"].indexOf("<") != 0) {
      xmlRes = `<?xml version="1.0"?><error> ${cont["content"]["response"]["xml"]} </error>`;
    } else {
      xmlRes = cont["content"]["response"]["xml"];
    }

    if (cont["content"]["request"]["xml"].indexOf("<") != 0) {
      xmlReq = `<?xml version="1.0"?><error>${cont["content"]["request"]["xml"]}</error>`;
    } else {
      xmlReq = cont["content"]["request"]["xml"];
    }

    setReqXml(xmlReq);
    setResXml(xmlRes);
  };

  return (
    <Dialog open={true} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle >
          {content["title"]}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} >
          <Tabs value={0} >
            <Tab label="JSON" onClick={changeTab.bind(this, "JSON")} sx={{borderBottom: tabActive === "JSON" ? "#3743aa solid 2px" : ""}}/>
            <Tab label="XML" onClick={changeTab.bind(this, "XML")} sx={{borderBottom: tabActive === "XML" ? "#3743aa solid 2px" : ""}}/>
          </Tabs>
        </Box>
        
        <DialogContent>					
          <Grid container spacing={2}>
            {content["content"] &&
              <Grid item xs={12}>
                Nombre del metodo: <b><label>{content["content"]["methodName"]}</label></b>
              </Grid>	
            }
            {content["content"] && content["content"]["cdate"] &&
              <Grid item xs={12} style={{paddingTop: "0px"}}>
                Fecha de creación: <b><label>{moment(new Date(content["content"]["cdate"])).format("LLL")}</label></b>
              </Grid>	
            }
            {content["content"] && content["content"]["udate"] &&
              <Grid item xs={12} style={{paddingTop: "0px"}}>
                Fecha de edición: <b><label>{moment(new Date(content["content"]["udate"])).format("LLL")}</label></b>
              </Grid>	
            }

            {tabActive == "JSON" && content["content"] && content["content"]["request"] && content["content"]["request"]["json"] &&
              <>
                <Grid item xs={12}>
                  REQUEST:
                  <ReactJson
                    name="data" src={reqJson} collapsed={true} displayDataTypes={false}
                    style={{ maxHeight: "600px", overflowY: "scroll", marginBottom: "30px" }}
                    />
                </Grid>
                <Grid item xs={12}>
                  RESPONSE:
                  <ReactJson
                    name="data" src={resJson} collapsed={true} displayDataTypes={false}
                    style={{ maxHeight: "600px", overflowY: "scroll", marginBottom: "30px" }}
                    />
                </Grid>
              </>
            }

            {tabActive == "XML" && content["content"] && content["content"]["request"] && content["content"]["request"]["xml"] &&
              <>
                <Grid item xs={12}>
                  REQUEST:
                  <XMLViewer
                    xml={reqXml} name="data" collapsed={true} collapsible={true} displayDataTypes={false}
                    style={{ maxHeight: "100px", overflowY: "scroll", marginBottom: "30px" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  RESPONSE:
                  <XMLViewer
                    xml={resXml} name="data" collapsed={true} collapsible={true} displayDataTypes={false}
                    style={{ maxHeight: "100px", overflowY: "scroll", marginBottom: "30px" }}
                  />
                </Grid>
              </>
            }
          </Grid> 
        </DialogContent>

        <DialogActions>    
          <Button variant="contained" onClick={closelightbox} >Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
  );
};

export default InfoLogTutuka;
